/**
 * Created by mykurisu on 2017/7/10.
 */
 import React from 'react'
 import axios from 'axios'
 import {connect} from 'react-redux'
 import {renderMoney, TimeStream} from '../utils'
 import qs from 'qs'
 import Clipboard from 'clipboard'
 import qr from 'qrcode';
 import '../styles/ShareCardSlide.css'
 import {
     Preload,
     WKError,
 } from '../components'
 import { WKGreenTitle, WKVisible } from '../components/wk'
 import {Toast, Mask, Button} from 'react-weui'
 import SharecardUpload from '../images/share_card_template_new.png'
 import SharecardUploadIcon from '../images/sharecard-slide-upload.png'
 import SharecardQrcodeIcon from '../images/sharecard-slide-qrcode.png'
 import SharecardSaleIcon from '../images/sharecard-slide-sale2.png'
 import SharecardSalePriceIcon from '../images/sharecard-slide-price.png'
 import SharecardErrorIcon from '../images/sharecard-slide-error.png'
 import SharecardDiy from '../images/sharecard-slide-diy.png'
 import errorImg from '../images/no-source.png'
 
 import classnames from 'classnames'
 import { setEvent } from '../utils'
 import { ShareList } from './shareCardSlide/ShareList'
 import {getAccessToken} from '../utils';
 import { isProdMainHost } from '../config'
 
 import { HTTPClient } from '@weike/toolkit'
 import config from '../config.js'
 import { WK_UPLOADER } from '@weike/uploader'
import OpenTips from './openTips'

import { Mask as WkMask } from './mask'

 const uploader = new WK_UPLOADER(process.env.NODE_ENV === 'production')
 
 const gwHttp = new HTTPClient({baseURL: config.BASE_URL_ELSE}, '0000')
 
 const maptypeStr = {
     liveroom: 'liveroom_sharecard',
     channel: 'channel_sharecard',
     lecture: 'recorded_lecture',
     liveroom_vip: 'liveroom_vip_sharecard'
 }
 class ShareCardSlide extends React.Component {
 
     constructor() {
         super();
         this.state = {
             cardInitialized: false,
             listInitialized: false,
             guideShow: false,
             typeList: null,
             selectType: '',
             sharecard: null,
             role: null,
             resell: null,
             resell_money:null,
             uploadShow: false,
             isError: false,
             showLoading: false,
             loadingTimer: null,
             qrImg: '',
             isShowQrDialog: false,
             isShowCopyToast: false,
             share_info: {},
             shortUrl: '',
             guideStep: 0,
             shareGuideShow: !localStorage.getItem('fe-share-card-show'),
             diyShow: true,
             copyShow: false,
             copyActive: 0,
             copyList: [],
             shareListActive: 0,
             liveroom_id: null,
             // 是否显示直播间进件提示
             visibleLiveroomApply: false,
             // 分销进件的提示信息
             /**
              * has_push: boolean
              * msg_type: string
              * title: string
              * url: string
              * content: string
              * eco_status: string
              * notify_type: string
              * title_icon: string
              * button_title: string
              */
             obj_reseller: null
         };
         this.handleGuideHide = this.handleGuideHide.bind(this);
         this.handleChangeType = this.handleChangeType.bind(this);
         this.handleTipsShow = this.handleTipsShow.bind(this);
         this.handleUploadShow = this.handleUploadShow.bind(this);
         this.handleUploadHide = this.handleUploadHide.bind(this);
         this.handleQrcodeShow = this.handleQrcodeShow.bind(this);
         this.handleImageUpload = this.handleImageUpload.bind(this);
         this.handleReload = this.handleReload.bind(this);
         this.handleResetImage = this.handleResetImage.bind(this);
         this.handleHoldStart = this.handleHoldStart.bind(this);
         this.touchin = this.touchin.bind(this);
         this.handleHoldEnd = this.handleHoldEnd.bind(this);
         this.superVipInit = this.superVipInit.bind(this);
         this.shareCardInfo = this.shareCardInfo.bind(this);
         this.touchin = this.touchin.bind(this);
         this.cardsCardGet = this.cardsCardGet.bind(this)
         this.handleApplyTip = this.handleApplyTip.bind(this)
     }
     cardsCardGetParams() {
         const { type, id } = this.props.sharecardSlide;
         const api_params = {
             card_type: maptypeStr[type],
             liveroom_id: type === 'liveroom' || type === 'liveroom_vip' ? Number(id) : undefined,
             object_type: type === 'liveroom_vip' ? 'liveroom' : type,
             object_id: Number(id), 
             target_type: type === 'liveroom_vip' ? 'liveroom' : type,
             target_id: Number(id),
             is_resell_center: window.location.search.indexOf('is_resell_center')> - 1
         }
         if(type === 'channel') {
             api_params.channel_id = Number(id)
         }
         if(type === 'lecture') {
             api_params.lecture_id = Number(id)
         }
         return api_params
     }
     cardsCardGet (templateId, api_params) {
         const { type } = this.props.sharecardSlide;
         const postUrl = '/v1/integration/wk_business_sharecard/cards.card.get'
         gwHttp.post(postUrl, {
             card_type: maptypeStr[type],
             api_params: api_params,
             template_id: templateId
           }).then(res=>{
             if (res.code === '0000') {
                 const shareCardInfo = (res.data.share_info && res.data.share_info.share_info) || {}
                 const resell =  res.data.share_info.resell
                 this.setState({
                     sharecard: {
                         ...res.data,
                         expire_time: shareCardInfo.expire_ts
                     },
                     role: res.data.share_info.role,
                     resell: resell,
                     cardInitialized: true,
                     share_info:  {
                         ...res.data.share_info,
                         share_url: shareCardInfo.share_url
                     },
                     diyShow: !res.data.share_info.is_close_diy,
                     selectType: res.data.template_id
                 });
                 this.props.dispatch({
                     type: 'UPDATE_SHARE_DATA',
                     payload: {
                         title: shareCardInfo.share_title,
                         desc: shareCardInfo.share_description,
                         imgUrl: shareCardInfo.share_icon,
                         type: 'link',
                         link: res.data.share_url,
                     }
                 });
                 if (resell && ((resell.money * resell.percent / 100) > 1)) {
                     this.handleApplyTip()
                 }
                 this.toQrImg(res.data.share_url)
                 //风控
                 this.context.page.showFengKongTip()
             } else {
                 this.handleError()
             }
         }).catch(() => {
             this.handleError()
         })
     }
 
     getCardsTemplatesList() {
         const { type, id} = this.props.sharecardSlide;
         gwHttp.post('v1/integration/wk_business_sharecard/cards.templates.list_get', {
             card_type: type + '_sharecard',
             target_id: Number(id)
         }).then((res) => {
             if (res.code === '0000') {
                 this.setState({
                     typeList: res.data.templates_list,
                     listInitialized: true
                 })
             } else {
                this.handleError()
             }
         }).catch((error) => {
             this.handleError()
         });
     }
 
     componentDidMount() {
         const { type, id } = this.props.sharecardSlide;
         const { accountId } = this.props
         setEvent('fe_sc_v', { type, id, test: accountId % 10 > 4 ? 'b' : 'a' })
         // 超级会员的业务已经砍掉了
         // if(type === 'supervip'){//超级会员分销
         //     this.superVipInit()
         //     return
         // }
         const api_params = this.cardsCardGetParams()
         gwHttp.post('/v1/integration/wk_business_sharecard/cards.records.template.get', {
            card_type: maptypeStr[type],
            api_params: { ...api_params},
        }).then((res) => {
            console.log('返回结果', res)
            this.setState({
                selectType: res.data.template_id,

            })
            const api_params = this.cardsCardGetParams()
            this.cardsCardGet(res.data.template_id, api_params)
        }).catch(error => {
            this.handleError()
        });
         this.getCardsTemplatesList()
         axios.get(`/api/sharecard/${id}/share_text`, {
             params: { type },
             // baseURL: 'http://129.204.145.169:8380'
         }).then(({ data: { data, code } }) => {
             if(code === 0) {
                 this.setState({
                     copyList: data.share_text
                 })
             }
         })
     }

     // 查询收付通进件提示
     handleApplyTip() {
         const { type, id } = this.props.sharecardSlide;
         gwHttp.post('/v1/integration/cont_manager/v1/api/saas/message_pull.applyment.get', {
             biz_list: ['obj_reseller'],
             obj_reseller: {
                 object_id: id,
                 object_type: type
             }
         }).then((res) => {
             if (res.data && res.data.obj_reseller) {
                 const isShow = !!Object.keys(res.data.obj_reseller).length && res.data.obj_reseller.content
                 this.setState({
                     obj_reseller: res.data.obj_reseller,
                     visibleLiveroomApply: isShow
                 })
                 if (isShow && res.data.obj_reseller) {
                     setEvent('fe_jj_v', {
                         type,
                         id,
                         eco_status: res.data.obj_reseller.url,
                         url: res.data.obj_reseller.url,
                         btn: res.data.obj_reseller.button_title
                     })
                 }
             }
         }).catch(error => {
            console.error('err', error)
         });
     }
     /**
      * 邀请卡请求失败时，判断是否为机构直播间的内容
      * 如果是，跳转到首页的地址为机构直播间主页
      *
      * @returns
      * @memberof ShareCardSlide
      */
     getHomePageURL() {
         const { type, id } = this.props.sharecardSlide;
         const requestURL = `/api/${type}/${id}/info`
         const token = getAccessToken()
         return axios.get(requestURL, { params: { token } })
             .then(res => res.data.data.liveroom.id)
             .then(liveroomId => {
                 const baseURL = !isProdMainHost ? 'https://gateway.test.weike.fm' : 'https://gateway-weike.lizhiweike.com'
                 return axios.post(`${baseURL}/config/check_whitelist_batch?version=1.0`, {
                     liveroom_id: liveroomId,
                     batch: {
                         tag: {
                             key: 'saas_whitelist',
                             server_name: 'liveroom_model',
                         }
                     }
                 }, {headers: {'Content-Type': 'application/json'}, params: { token }})
                 .then(res => res.data.data.tag)
                 .then(isSaaS => {
                     return isSaaS ? `/liveroom2/${liveroomId}` : '/?st=sharecard_404'
                 }).catch(() => false)
             }).catch(() => '/?st=sharecard_404')
     }
 
     handleError() {
         this.getHomePageURL().then(url => {
             this.props.dispatch({
                 type: 'ERROR_SHOW',
                 payload: {
                     tips: '邀请卡加载出现问题。',
                     img: errorImg,
                     href: url,
                     btn: '去首页看看'
                 }
             });
         })
     }
 
     superVipInit(){
         axios.get(`/api/member/all_themes`).then(res => {
             if (res.data.code === 0) {
                 this.setState({
                     typeList: res.data.data.templates_list,
                     listInitialized: true
                 })
                 this.shareCardInfo(res.data.data.templates_list[0].template_id)
             }
         }).catch((error) => {
             this.handleError()
         });
     }
     shareCardInfo(template_id){
         axios.get(`/api/member/share_card_info`, {
             params: {
                 template_id: template_id
             }
         }).then(res => {
             if (res.data.code === 0) {
                 this.setState({
                     sharecard: res.data.data.sharecard,
                     cardInitialized: true,
                     share_info:res.data.data.share_info,
                     resell_money:res.data.data.resell_money
                 });
                 this.toQrImg(res.data.data.sharecard.qrcode_content)
                 this.props.dispatch({
                     type: 'UPDATE_SHARE_DATA',
                     payload: {
                         title: res.data.data.share_info.share_title,
                         desc: res.data.data.share_info.share_description,
                         imgUrl: res.data.data.share_info.share_icon,
                         type: 'link',
                         link: res.data.data.share_info.share_url,
                     }
                 });
             }
         }).catch((error) => {
             this.handleError()
         });
     }
 
     handleHoldStart() {
         this.sTime = Date.parse(new Date());
     }
 
     handleHoldEnd() {
         const {type, id, inviterId} = this.props.sharecardSlide;
         this.eTime = Date.parse(new Date());
         if (this.eTime - this.sTime > 500) {
             this.props.dispatch({
                 type: "STATS_LOG",
                 payload: {
                     action: 'longpress_sharecard',
                     ts: new Date().getTime(),
                     obj_type: type,
                     obj_id: id,
                     inviter_id: inviterId ? inviterId : '',
                 }
             })
         }
     }
 
     handleReloadList() {
         const {type, id} = this.props.sharecardSlide;
         axios.get(`/api/sharecard/${id}/all_theme`, {
             params: {
                 type: type,
             }
         }).then(res => {
             if (res.data.code === 0) {
                 this.setState({
                     typeList: res.data.data.template_list,
                 })
             }
         });
     }
 
     handleChangeType(e, tem_id, url) {
         const {id, type} = this.props.sharecardSlide;
         const {role, selectType} = this.state;
         if(selectType === Number(tem_id)) {
             return
         }
         let index = Number(e.target.getAttribute('data-index'));
         let width = document.querySelector('.sharecard-slide-page').clientWidth;
         if (width < 480) {
             if (role && role.is_manager) {
                 if (index <= 1) {
                     this.refs.SharecardSlideList.scrollLeft = 0
                 } else if (index === 2) {
                     this.refs.SharecardSlideList.scrollLeft = 63
                 } else {
                     this.refs.SharecardSlideList.scrollLeft = 63 + (index - 2) * 69
                 }
             } else {
                 if (index <= 2) {
                     this.refs.SharecardSlideList.scrollLeft = 0
                 } else if (index === 3) {
                     this.refs.SharecardSlideList.scrollLeft = 63
                 } else {
                     this.refs.SharecardSlideList.scrollLeft = 63 + (index - 3) * 69
                 }
             }
         }
         const api_params = this.cardsCardGetParams()
         if(String(tem_id).indexOf('custom') !== -1) {
             api_params.base_image = url
             api_params.is_custom = true
             this.cardsCardGet(tem_id, api_params)
         } else {
             this.cardsCardGet(Number(tem_id), api_params)
         }
         
         
         this.context.page.showToast('邀请卡请求中', 'loading');
     }
 
 
     handleGuideHide() {
         this.setState({
             guideShow: false
         })
     }
 
     handleReload() {
         window.location.reload()
     }
 
     handleTipsShow() {
         const {type} = this.props.sharecardSlide;
         let text = () => {
             return (
                 <div className="sharecard-slide-page-qrcode_container">
                     <p className="sharecard-slide-page-qrcode_container-title">邀请收益</p>
                     <div className="sharecard-slide-page-sale_container-icon">
                         <img src={SharecardSalePriceIcon} alt=""/>
                     </div>
                     <p className="sharecard-slide-page-sale_container-tips">1. 长按图片进行保存，可以转发至好友组队一起学习</p>
                     <p className="sharecard-slide-page-sale_container-tips">2. 每成功邀请一名好友，可以获得本
                         {type === 'lecture' && '课程'}
                         {type === 'channel' && '专栏'}
                         {type === 'liveroom' && '直播间'}
                         费用的<span className="key-num">{this.state.resell.percent}%</span></p>
                 </div>
             )
         };
         this.context.page.showAlert(text())
     }
 
     handleUploadShow() {
         this.setState({
             uploadShow: true
         })
     }
 
     handleUploadHide() {
         this.setState({
             uploadShow: false
         })
     }
 
     toQrImg (str) {
         qr.toDataURL(str, {
             errorCorrectionLevel: 'M',
             margin: 2,
             type: 'image/png',
         }, (err, url) => {
             if (err) throw err
             this.setState({ qrImg: url })
         })
     }
 
     handleQrcodeShow() {
         this.setState({ isShowQrDialog: true })
         if (!this.state.shortUrl) {
             axios.post('/api/short/create', qs.stringify({
                 url: this.state.share_info.share_url
             }))
                 .then(res => {
                     this.setState({ shortUrl: res.data.data.short_url })
                 })
             this.initCopyboard()
         }
     }
 
     handleImageUpload() {
         const {id, type} = this.props.sharecardSlide;
         const file = this.refs.ImageUpload.files[0]
         const names = file.name.split('.')
         const typeFlag = ['jpg', 'png', 'jpeg']
         if(!typeFlag.includes(names[1])) {
             this.context.page.showAlert(`文件必须为${String(typeFlag)}`);
             return
         }
         let reader = new FileReader();
         reader.readAsDataURL(file);
         reader.onloadend = (res)=>{
             let image = new Image();
             if(res.target && res.target.result) {
                 (image.src) = res.target.result;
                 image.onload = ()=>{
                     console.log(image.width, image.height)
                     if(image.width !== 640 ||  image.height !== 1040) {
                         this.context.page.showAlert('图片宽和高分别必须为640和1040px');
                         return
                     }
                     uploader.upload({
                         file: this.refs.ImageUpload.files[0],
                         options: {
                         namespace: 85465704,
                         class: 'lecture'
                         }
                     })
                     .then((res) => {
                         const api_params = this.cardsCardGetParams()
                         api_params.base_image = res.url
                         api_params.is_custom = true
                         gwHttp.post('/v1/integration/wk_business_sharecard/cards.upload_custom_sharecard.add', {
                             card_type: maptypeStr[type],
                             target_type: type,
                             target_id: Number(id),
                             image_address: res.url
                         }).then(() => {
                             this.setState({
                                 uploadShow: false,
                             })
                             this.cardsCardGet('', api_params)
                             this.getCardsTemplatesList()
                         }).catch(() => {
                             this.context.page.showAlert('上传失败')
                         })
                     }).catch(() => {
                         this.context.page.showAlert('上传失败')
                     })
                 }
             }
         }
     }

     // 恢复默认
     handleResetImage() {
         const {id, type} = this.props.sharecardSlide;
         gwHttp.post('/v1/integration/wk_business_sharecard/cards.update.custom_sharecard_state.add', {
            card_type: maptypeStr[type],
            target_type: type,
            target_id: Number(id),
        }).then(() => {
            this.setState({
                uploadShow: false,
            })
            const api_params = this.cardsCardGetParams()
            this.cardsCardGet('', api_params)
            this.getCardsTemplatesList()
        }).catch((res) => {
            this.context.page.showAlert(res.message || '恢复默认失败')
        })
        this.context.page.showToast('恢复默认', 'loading');
         
     }
 
     // 引导
     renderGuide() {
         if(!this.state.shareGuideShow) return null
         if(this.state.guideStep > 1) {
             localStorage.setItem('fe-share-card-show', 'true')
             return null
         }
         return <div className="sharecard-guide">
             <div className="sharecard-slide-page-mask"></div>
             <div
                 className="sharecard-guide-container"
                 onClick={
                     () => {
                         this.setState({
                             guideStep: this.state.guideStep + 1
                         })
                     }
                 }
             >
                 {
                     this.state.guideStep === 0 && 
                         <img 
                            className="sharecard-guide-step0"
                            src="https://static-1253442168.file.myqcloud.com/xupload/20200311_长按保存.png" 
                         />
                 }
                {
                     this.state.guideStep === 1 && 
                         <img 
                            className="sharecard-guide-step1"
                            src="https://static-1253442168.file.myqcloud.com/xupload/20200311_第三步分享文案.png"
                         />
                 }
             </div>
         </div>
     }
 
     renderShareCopy() {
         if(!this.state.copyShow) return null
         return <div className="sharecard-slide-page-copy">
             <div 
               className="sharecard-slide-page-mask"
               onClick={() => {
                 this.setState({ copyShow: false })
               }}
             />
             <div className="sharecard-slide-page-copy-container">
                 <div className="sharecard-slide-page-copy-title">
                     <span>选择分享文案</span>
                     <img 
                       src="https://static-1253442168.file.myqcloud.com/xupload/20200314_关闭.png" 
                       onClick={() => {
                           this.setState({ copyShow: false })
                       }}
                     />
                 </div>
                 <div className="sharecard-slide-page-copy-list">
                    {
                        this.state.copyList.map((val, key) => {
                             return <div 
                               className={
                                 classnames(
                                     'sharecard-slide-page-copy-item',
                                     this.state.copyActive === key && 'sharecard-slide-page-copy-active'
                                 )
                               }
                               key={key + '-copy-item'}
                               onClick={() => {
                                   this.setState({
                                     copyActive: key
                                   })
                               }}
                             >
                                 { val && val.content ? val.content : '' }
                             </div>
                        })
                    }
                 </div>
                 <div className="sharecard-slide-page-copy-bottom">
                     <button 
                       className="sharecard-slide-page-copy-button"
                       id="copy-share-button"
                       data-clipboard-text={this.state.copyList[this.state.copyActive].content || ''}
                     >
                         复制文案
                     </button>
                 </div>
             </div>
         </div>
     }
 
     handleShareCopy() {
         let clipboard = new Clipboard('#copy-share-button');
         clipboard.on('success', (e) => {
             const { type, id } = this.props.sharecardSlide;
             setEvent('fe_sc_cp_st_evt', { 
                 type, 
                 id, 
                 index: this.state.copyActive
             })
             this.context.page.showToast('复制成功，赶快去分享吧~');
             e.clearSelection();
         });
     }
 
     renderUpload() {
         return (
             <div className="sharecard-slide-page-upload" style={{right: this.state.uploadShow ? '0' : '-100%'}}>
                 <img src={SharecardUpload} alt=""/>
                 <div className="weui-flex sharecard-slide-page-upload_btn">
                     <div className="weui-flex__item sharecard-slide-page-upload_btn-item"
                          onClick={this.handleUploadHide}>
                         <a className="upload-button btn-cancel">返回</a>
                     </div>
                     <div className="weui-flex__item sharecard-slide-page-upload_btn-item"
                          onClick={this.handleResetImage}>
                         <a className="upload-button btn-upload-cover">恢复默认</a>
                     </div>
                     <div className="weui-flex__item sharecard-slide-page-upload_btn-item sharecard-slide-page-upload_btn_up">
                         <input id="inputImage" type="file" ref="ImageUpload" onClick={() => {
                             this.refs.ImageUpload.value = ''
                         }} onChange={this.handleImageUpload}
                                style={{opacity: '0'}}/>
                         <a className="upload-button qr-bottom-button-copy btn-upload-cover">上传图片</a>
                     </div>
                 </div>
                 <div className="text-justify sharecard-slide-page-upload_text">
                     <p>1. 上传背景图的尺寸为<span className="key-num">640*1040</span></p>
                     <p>2. 上传成功后，即刻生成邀请卡</p>
                 </div>
             </div>
         )
     }
 
     renderQrcode() {
         return (
             <div 
               className={`sharecard-slide-page-qrcode`} 
               onClick={this.handleQrcodeShow}
             >
                 <div className={`sharecard-slide-page-qrcode-tip`}>二维码非永久有效</div>
                 <img src="https://static-1253442168.file.myqcloud.com/xupload/20200310_二维码icon.png" alt=""/>
             </div>
         )
     }
 
     renderShareText() {
         if(location.href.indexOf('liveroom') > -1 || this.state.copyShow) {
             return null
         }
         this.handleShareCopy()
         return (
             <div 
               className={
                 classnames(
                     "share-slide-page-share-text-button",
                     this.state.shareGuideShow && this.state.guideStep === 1 && "share-slide-page-share-text-button-guide"
                 )
               }
               onClick={() => {
                   this.setState({ copyShow: true })
               }}
             >
                 <img src="https://static-1253442168.file.myqcloud.com/xupload/20200310_分享文案icon.png" />
                 <span>分享文案</span>
             </div>
         )
     }
 
     renderSalesTips(money) {
         return (
             <div className="sharecard-slide-page-tips">
                 <span className="sharecard-slide-page-tips_icon">
                     <img src={SharecardSaleIcon} alt=""/>
                 </span>
                 <span>
                     {renderMoney(money)}元
                 </span>
             </div>
         )
     }
 
     renderShareList() {
         const that = this
         this.shareListTimer && clearTimeout(this.shareListTimer)
         this.shareListTimer = setTimeout(() => {
            const index = that.state.shareListActive + 1
            that.setState({ shareListActive: index > 9 ? 0 : index  })
         }, 3000)
 
         return (
             <div className="sharecard-slide-sharelist">
                <div 
                   className="sharecard-slide-active"
                   key={this.state.shareListActive}
                 >
                   <img 
                     className="sharecard-slide-sharelist-avatar"
                     src={ShareList[this.state.shareListActive].img}
                   />
                   <span>{ShareList[this.state.shareListActive].name}2秒前分享了课程</span>
                </div>  
             </div>
         )
     }
 
     showToast (text) {
         this.setState({
             isShowCopyToast: true
         })
         setTimeout(() => {
             this.setState({
                 isShowCopyToast: false
             })
         }, 2000)
     }
 
     initCopyboard () {
         const clipboard = new Clipboard('#copy-btn')
         clipboard.on('success', (e) => {
             this.showToast('已复制')
             e.clearSelection()
         })
     }
 
     touchin () {
         if(this.timer) {
             clearInterval(this.timer) //再次清空定时器，防止重复注册定时器
         }
         const { accountId } = this.props
         const { type, id } = this.props.sharecardSlide;
         this.timer = setTimeout(async () => {
             setEvent('fe_sc_qr_lp_evt', { type, id, test: accountId % 10 > 4 ? 'b' : 'a' })
         }, 800)
     }

     // 分销进件提示
     renderApplymentTip() {
         if (!this.state.visibleLiveroomApply) {
             return
         }
         const obj_reseller = this.state.obj_reseller
         const { type, id } = this.props.sharecardSlide;
         if (!obj_reseller) {
             return
         }
         const { title, url, content, title_icon, button_title, eco_status } = obj_reseller
         return (
             <WkMask>
                 <div className={'liveroom-apply-ment'}>
                     <div className={'liveroom-apply-ment-content'}>
                         <div className={'liveroom-apply-ment-title'}>
                             {title_icon && <img className={'liveroom-apply-ment-title-icon'} src={title_icon}  alt=''/>}{title}
                         </div>
                         <div className={'liveroom-apply-ment-tip'} dangerouslySetInnerHTML={{ __html: content }} />
                         <div
                             className="common-weike-primary-btn"
                             onClick={() => {
                                 setEvent('fe_jj_ck', {
                                     type,
                                     id,
                                     eco_status,
                                     url,
                                     btn: button_title
                                 })
                                 if (url) {
                                     setTimeout(() => {
                                         location.assign(url)
                                     },200)
                                 }
                                 this.setState({
                                     visibleLiveroomApply: false
                                 })
                             }}
                         >
                             {button_title}
                         </div>
                     </div>

                     <div
                         className={'liveroom-apply-ment-close'}
                         onClick={() => {
                             this.setState({
                                 visibleLiveroomApply: false
                             })
                         }}
                     >
                         X
                     </div>
                 </div>
             </WkMask>
         )
     }

     render() {
         const {sharecard, cardInitialized, listInitialized, role, resell, resell_money} = this.state;
 
         const { error, sharecardSlide, accountId } = this.props;
         
         if (error.showError) {
             return (
                 <div className="sharecard-slide-page_error">
                     <WKError />
                 </div>
             )
         }
         
         if (!cardInitialized || !listInitialized) {
             return <Preload />
         }
         return (
             <div className="sharecard-slide-page">

                {/*{ resell && ((resell.money * resell.percent / 100) > 1) &&*/}
                {/*  <OpenTips page={this.context.page} sharecardSlide={this.props.sharecardSlide} /> }*/}

                 <Toast icon="loading" show={this.state.showLoading}>邀请卡生成中</Toast>
 
                 {
                   role && role.is_manager &&
                     this.renderUpload()
                 }
 
                 {/* {this.renderGuide()} */}
                  
                 {/* 左上角分享名单 */}
                 { this.renderShareList() }
 
                 {/* 复制文案界面 */} 
                 { this.renderShareText() } 
 
                 {/* 复制文案按钮 */} 
                 { this.renderShareCopy() } 
 
                 { this.renderQrcode() }
 
                 {
                   resell && ((resell.money * resell.percent / 100) > 1) &&
                   this.renderSalesTips(resell.money * resell.percent / 100)
                 }
                 {
                   resell_money &&
                   this.renderSalesTips(resell_money)
                 }
                 <div 
                   className={`sharecard-slide-page-top`}
                 >
                     {
                         this.state.isError ? 
                         <div className="sharecard-slide-page-top_error">
                             <img src={SharecardErrorIcon} alt=""/>
                             <p onClick={this.handleReload}>重新加载</p>
                         </div>
 
                         : <div 
                                className={`sharecard-slide-page-top_content`} 
                                onTouchStart={() => {
                                    this.touchin()
                                    this.handleHoldStart()
                                }}
                                onTouchEnd={() => {
                                    this.handleHoldEnd()
                                    this.timer && clearInterval(this.timer)
                                }}
                           >
                             <img
                                 ref="ShareCardImage"
                                 src={sharecard.card_url}
                                 id="sharecard-slide"
                             />
                         </div>
                     }
                 </div>
                 <div className={`sharecard-slide-page-footer`}>
                     <p>长按上方图片发送给好友</p>
                     <div
                         className={(role && role.is_manager && (this.props.sharecardSlide.type !== 'schedule') && this.state.diyShow) ? "sharecard-slide-page-footer_list-container-manager" : "sharecard-slide-page-footer_list-container"}>
                         {role && role.is_manager && (this.props.sharecardSlide.type !== 'schedule') && this.state.diyShow &&
                         <div className="sharecard-slide-page-footer_list-upload" onClick={this.handleUploadShow}>
                             <img
                                 src={SharecardDiy}
                                 alt=""/>
                         </div>
                         }
                         <div className="sharecard-slide-page-footer_list" ref="SharecardSlideList">
                             {//超级会员只有一张邀请卡 点击没有对应接口
                                 sharecardSlide.type === 'supervip' &&
                                 <span className="sc-clide-active">
                                     <img
                                         data-id={this.state.typeList[0].template_id}
                                         src={this.state.typeList[0].avatar}
                                         alt=""/>
                                 </span>
                             }
                             {sharecardSlide.type !== 'supervip' && this.state.typeList && this.state.typeList.map((item, i) =>
                                 <span className={String(this.state.selectType) === String(item.template_id) ? "sc-clide-active" : ''}
                                       key={item.template_id}
                                       onClick={(e) => this.handleChangeType(e, item.template_id, item.avatar)}>
                                             <img
                                                 data-id={item.template_id}
                                                 data-index={i}
                                                 src={item.avatar}
                                                 alt=""/>
                                         </span>
                             )}
                         </div>
                     </div>
                 </div>
                 {this.renderApplymentTip()}
                 <WKVisible show={this.state.isShowQrDialog}>
                     <div className="qr-dialog">
                         <Mask />
                         <div className="content">
                             <div className="content-title">添加二维码或链接至宣传渠道</div>
                             <div className="content-sub-title">方法一：长按二维码保存</div>
                             <div className="qr">
                                 <img 
                                   onTouchStart={this.touchin}
                                   onTouchEnd={() => {
                                     this.timer && clearInterval(this.timer)
                                   }}
                                   src={this.state.qrImg} 
                                   alt="二维码"
                                 />
                             </div>
                             <div className="qr-desc">二维码过期时间为：{TimeStream(sharecard.expire_time, 'YMD')}</div>
                             <div className="content-sub-title">方法二：点击复制链接</div>
                             <div className="url-wrap">{this.state.shortUrl}</div>
                             <div className="qr-bottom">
                                 <div
                                   className={
                                     classnames(
                                         "qr-bottom-button",
                                         "qr-bottom-button-cancel"
                                     )
                                   }
                                   onClick={e => this.setState({ isShowQrDialog: false })}
                                 >
                                     关闭
                                 </div>
                                 <button
                                   id='copy-btn' 
                                   data-clipboard-text={this.state.shortUrl}
                                   className={
                                       classnames(
                                           "qr-bottom-button",
                                           "qr-bottom-button-copy"
                                       )
                                   }
                                 >
                                    复制链接
                                 </button>
                             </div>
                         </div>
                     </div>
                 </WKVisible>
                 <Toast icon="success-no-circle" show={this.state.isShowCopyToast}>复制成功</Toast>
             </div>
         )
     }
 }
 
 ShareCardSlide.contextTypes = {
     page: React.PropTypes.object,
 };
 
 export default connect((state) => ({
     error: state.error,
     accountId: state.account.id,
 }))(ShareCardSlide)
 


// WEBPACK FOOTER //
// ./src/components/ShareCardSlide.js